import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Base URL
const BASE_URL =  process.env.REACT_APP_API_URL;

// Async thunk for fetching employees
export const fetchEmployees = createAsyncThunk(
  "employees/fetchEmployees",
  async (params = {}, { rejectWithValue }) => {
    try {
      const { page = 1, page_size = 20, search = "" } = params;
      const response = await axios.get(`${BASE_URL}/Employees/`, {
        params: { page, page_size, search },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "فشل في جلب بيانات الموظفين"
      );
    }
  }
);

// Async thunk for fetching single employee
export const fetchEmployeeById = createAsyncThunk(
  "employees/fetchEmployeeById",
  async (employeeId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/Employees/${employeeId}/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "فشل في جلب بيانات الموظف"
      );
    }
  }
);

const employeesSlice = createSlice({
  name: "employees",
  initialState: {
    employees: [],
    currentEmployee: null,
    summary: null,
    loading: false,
    error: null,
    pagination: {
      current_page: 1,
      total_pages: 1,
      page_size: 20,
      count: 0,
      has_next: false,
      has_previous: false,
    },
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearCurrentEmployee: (state) => {
      state.currentEmployee = null;
    },
  },
  extraReducers: (builder) => {
    // Fetch employees
    builder
      .addCase(fetchEmployees.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmployees.fulfilled, (state, action) => {
        state.loading = false;
        state.employees = action.payload.employees;
        state.summary = action.payload.summary;
        state.pagination = {
          current_page: action.payload.current_page,
          total_pages: action.payload.total_pages,
          page_size: action.payload.page_size,
          count: action.payload.count,
          has_next: action.payload.has_next,
          has_previous: action.payload.has_previous,
        };
      })
      .addCase(fetchEmployees.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch single employee
      .addCase(fetchEmployeeById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmployeeById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentEmployee = action.payload.employee;
      })
      .addCase(fetchEmployeeById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearCurrentEmployee } = employeesSlice.actions;
export default employeesSlice.reducer;